import {
  Component,
  ViewEncapsulation
} from '@angular/core';



export class MdlLayoutSpacerComponent {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mdl-layout-spacer',
  host: {
    '[class.mdl-layout-spacer]': 'true'
  },
  template: '',
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
